import type { ModerationState, VisibilityChange } from '../types'

/** Retry-After доступен только в meta ответа — кладём рядом с телом для parseModerationError. */
export const withRetryAfter = (err: object, meta?: { response?: Response }) => ({
  ...err,
  retryAfterHeader: Number(meta?.response?.headers.get('Retry-After')) || undefined,
})

/** 202 — запущена проверка (тело `{reviewId}`), 200 — применено сразу (`ModerationState`). */
export const toVisibilityChange = (
  body: ModerationState | { reviewId: number },
  meta?: { response?: Response },
): VisibilityChange =>
  meta?.response?.status === 202
    ? { kind: 'review', reviewId: (body as { reviewId: number }).reviewId }
    : { kind: 'applied', state: body as ModerationState }
